import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { InsuranceIcon, TickIcon } from '@sainsburys-tech/bolt-icons';
import ModalSkeleton from '../../containers/Modal/Modal.Skeleton';
import ProductFetch from '../Fetch/Fetch';
import TrolleyItemList from '../TrolleyItemList/TrolleyItemList';
import { onRecommendationClicked } from '../../helpers/tracking';
import careTypes from '../WarrantyItem/config/careTypes';
import * as Styled from './ModalSuccessState.styles';

var getMonthlyCare = function getMonthlyCare() {
  var ProductExtraData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _ref = ProductExtraData.length > 0 && ProductExtraData.find(function (data) {
    return data.type === 'productCare';
  }) || {},
      _ref$attributes = _ref.attributes;

  _ref$attributes = _ref$attributes === void 0 ? {} : _ref$attributes;
  var _ref$attributes$warra = _ref$attributes.warranties,
      warranties = _ref$attributes$warra === void 0 ? [] : _ref$attributes$warra,
      hostId = _ref.id;
  var monthlyCare = warranties.length > 0 && warranties.find(function (attr) {
    return attr.type.startsWith('monthly_care');
  });
  return monthlyCare ? _objectSpread(_objectSpread({}, monthlyCare), {}, {
    id: monthlyCare.sku,
    placement: 'warranties',
    model: 'warranties',
    data: {
      attributes: {
        price: {
          now: monthlyCare.price
        },
        name: 'Argos Monthly Care'
      }
    },
    hostId: hostId
  }) : false;
};

var countWarranties = function countWarranties() {
  var ProductExtraData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _ref2 = ProductExtraData.length > 0 && ProductExtraData.find(function (data) {
    return data.type === 'productCare';
  }) || {},
      _ref2$attributes = _ref2.attributes;

  _ref2$attributes = _ref2$attributes === void 0 ? {} : _ref2$attributes;
  var _ref2$attributes$warr = _ref2$attributes.warranties,
      warranties = _ref2$attributes$warr === void 0 ? [] : _ref2$attributes$warr;
  return warranties.length;
};

var getMainProductForExtraItem = function getMainProductForExtraItem(essentialExtraId, essentialExtraItems) {
  var _extraItemUnit$meta;

  // Getting extra item data
  var extraItemUnit = essentialExtraItems.find(function (item) {
    return item.id === essentialExtraId;
  }); // Getting main product id related to the extra item

  return extraItemUnit === null || extraItemUnit === void 0 ? void 0 : (_extraItemUnit$meta = extraItemUnit.meta) === null || _extraItemUnit$meta === void 0 ? void 0 : _extraItemUnit$meta.entity;
};

var getMainProductDataPerId = function getMainProductDataPerId(productId, products, itemsAttributes) {
  var _included$find, _itemsAttributes$prod;

  var extraItemMainProduct = products[productId];
  var _extraItemMainProduct = extraItemMainProduct.data,
      mainProductId = _extraItemMainProduct.id,
      mainProductName = _extraItemMainProduct.attributes.name,
      included = extraItemMainProduct.included;
  var mainProductPrice = (_included$find = included.find(function (item) {
    return item.type === 'prices';
  })) === null || _included$find === void 0 ? void 0 : _included$find.attributes.now;
  var mainProductQuantity = (_itemsAttributes$prod = itemsAttributes[productId]) === null || _itemsAttributes$prod === void 0 ? void 0 : _itemsAttributes$prod.quantity;
  return {
    id: mainProductId,
    name: mainProductName,
    price: mainProductPrice,
    quantity: mainProductQuantity
  };
};

export var getMainCareType = function getMainCareType(warranties, monthlyCare) {
  if (warranties.length > 0 && warranties[0].type === 'mobile_care') {
    return warranties[0].type;
  }

  if (monthlyCare && monthlyCare.type) {
    return monthlyCare.type;
  }

  if (warranties.length > 0) {
    return warranties[0].type;
  }

  return '';
};

var ModalSuccessState = function ModalSuccessState(_ref3) {
  var hideExtras = _ref3.hideExtras,
      hideWarranties = _ref3.hideWarranties,
      hideCategories = _ref3.hideCategories,
      addedItems = _ref3.addedItems,
      addedItemsAttributes = _ref3.addedItemsAttributes,
      extraItems = _ref3.extraItems,
      extraItemsMeta = _ref3.extraItemsMeta,
      warrantyItems = _ref3.warrantyItems,
      categoryItems = _ref3.categoryItems,
      categoryItemsMeta = _ref3.categoryItemsMeta,
      trackingPage = _ref3.trackingPage,
      trackingPageId = _ref3.trackingPageId,
      onClickAdd = _ref3.onClickAdd,
      dataTest = _ref3['data-test'],
      partNumbers = _ref3.partNumbers,
      warrantyItemsList = _ref3.warrantyItemsList,
      extraItemsList = _ref3.extraItemsList,
      isReady = _ref3.isReady,
      setItemsLoaded = _ref3.setItemsLoaded;
  var trackingOptions = {
    page: trackingPage,
    pageId: trackingPageId,
    mainProductId: addedItems[0]
  };

  var handleClick = function handleClick(info) {
    onRecommendationClicked(info);
    onClickAdd(info);
  };

  return /*#__PURE__*/React.createElement(ProductFetch, {
    hostPartNumber: addedItems && addedItems[0],
    partNumbers: partNumbers,
    render: function render(_ref4) {
      var _products$partNumbers, _careTypes$mainCareTy, _careTypes$mainCareTy2;

      var products = _ref4.products,
          isLoading = _ref4.isLoading,
          inError = _ref4.inError;

      // fixes bug where same partNumber appears multiple times in array
      var pnWithErrors = _toConsumableArray(new Set(inError)).length;

      if (isLoading || Object.keys(products).length + pnWithErrors < _toConsumableArray(new Set(partNumbers)).length) return /*#__PURE__*/React.createElement(ModalSkeleton, {
        partNumbers: addedItems
      });
      setItemsLoaded(true);
      var monthlyCare = getMonthlyCare(products[partNumbers[0]].included);
      var mainCareType = getMainCareType(warrantyItems, monthlyCare);
      var showWarrantyItems = !hideWarranties && (warrantyItemsList.length > 0 || monthlyCare);
      var showExtraItems = !hideExtras && extraItemsList.length > 0;
      var showCategoryItems = !hideCategories && categoryItems.length > 0;
      var productModuleIndex = -1;
      var warrantyModuleIndex = 0;
      var extraModuleIndex = warrantyModuleIndex + (showWarrantyItems ? 1 : 0);
      var categoryModuleIndex = extraModuleIndex + (showExtraItems ? 1 : 0);
      return /*#__PURE__*/React.createElement("div", {
        className: isReady ? '' : 'xs-hidden'
      }, /*#__PURE__*/React.createElement(TrolleyItemList, {
        products: products,
        items: addedItems,
        itemsAttributes: addedItemsAttributes,
        itemType: "primary",
        trackingOptions: trackingOptions,
        showQuantity: true,
        showButton: false,
        showPrice: false,
        moduleIndex: productModuleIndex,
        "data-test": "".concat(dataTest, "-items-primary")
      }), showWarrantyItems && /*#__PURE__*/React.createElement(TrolleyItemList, {
        products: monthlyCare ? _objectSpread(_objectSpread({}, products), {}, _defineProperty({}, monthlyCare.sku, monthlyCare)) : products,
        items: monthlyCare ? warrantyItemsList.concat(monthlyCare.sku) : warrantyItemsList,
        itemsData: monthlyCare ? warrantyItems.concat(monthlyCare) : warrantyItems,
        itemsAttributes: addedItemsAttributes,
        itemType: "warranty",
        limit: 2,
        trackingOptions: trackingOptions,
        onClick: handleClick,
        moduleIndex: warrantyModuleIndex,
        "data-test": "".concat(dataTest, "-items-warranty"),
        primaryCare: careTypes[mainCareType],
        careCount: countWarranties(products === null || products === void 0 ? void 0 : (_products$partNumbers = products[partNumbers === null || partNumbers === void 0 ? void 0 : partNumbers[0]]) === null || _products$partNumbers === void 0 ? void 0 : _products$partNumbers.included)
      }, /*#__PURE__*/React.createElement(Styled.ListHeading, {
        "data-test": "".concat(dataTest, "-warranty-heading")
      }, /*#__PURE__*/React.createElement(InsuranceIcon, {
        height: "20px",
        width: "20px",
        fill: "#333"
      }), "Protect your product today with Argos Care to benefit from:"), /*#__PURE__*/React.createElement(Styled.Description, null, /*#__PURE__*/React.createElement("ul", null, mainCareType && ((_careTypes$mainCareTy = careTypes[mainCareType]) === null || _careTypes$mainCareTy === void 0 ? void 0 : (_careTypes$mainCareTy2 = _careTypes$mainCareTy.benefits) === null || _careTypes$mainCareTy2 === void 0 ? void 0 : _careTypes$mainCareTy2.map(function (benefit, index) {
        return /*#__PURE__*/React.createElement("li", {
          key: index
        }, /*#__PURE__*/React.createElement(Styled.Circle, null, /*#__PURE__*/React.createElement(TickIcon, {
          height: "15px",
          width: "15px"
        })), /*#__PURE__*/React.createElement(Styled.ContentListText, {
          dangerouslySetInnerHTML: {
            __html: benefit
          }
        }));
      }))))), showExtraItems && /*#__PURE__*/React.createElement(TrolleyItemList, {
        products: products,
        items: extraItemsList,
        itemsData: extraItems,
        itemType: "extra",
        limit: 2,
        trackingOptions: trackingOptions,
        onClick: function onClick(info) {
          // Getting main product related to the essential extra item
          var extraItemMainProductId = getMainProductForExtraItem(info.id, extraItems); // Getting the main product data for specific product SKU

          var essentialExtraRelatedMainProduct = getMainProductDataPerId(extraItemMainProductId, products, addedItemsAttributes);

          var additionalInfo = _objectSpread(_objectSpread({}, info), {}, {
            mainProduct: _objectSpread({}, essentialExtraRelatedMainProduct)
          });

          onRecommendationClicked(additionalInfo);
          onClickAdd(info);
        },
        moduleIndex: extraModuleIndex,
        "data-test": "".concat(dataTest, "-items-extra")
      }, /*#__PURE__*/React.createElement(Styled.ListHeading, {
        "data-test": "".concat(dataTest, "-extra-heading")
      }, extraItemsMeta && extraItemsMeta.placementTitle)), showCategoryItems && /*#__PURE__*/React.createElement(TrolleyItemList, {
        products: products,
        items: categoryItems,
        itemsAttributes: categoryItemsMeta,
        itemType: "category",
        trackingOptions: trackingOptions,
        onClick: handleClick,
        moduleIndex: categoryModuleIndex,
        "data-test": "".concat(dataTest, "-items-category")
      }, /*#__PURE__*/React.createElement(Styled.ListHeading, {
        "data-test": "".concat(dataTest, "-category-heading")
      }, categoryItemsMeta && categoryItemsMeta.placementTitle || 'Have you thought about...?')));
    }
  });
};

ModalSuccessState.propTypes = {
  hideExtras: PropTypes.bool,
  hideWarranties: PropTypes.bool,
  hideCategories: PropTypes.bool,
  onClickAdd: PropTypes.func,
  addedItems: PropTypes.array,
  extraItems: PropTypes.array,
  warrantyItems: PropTypes.array,
  categoryItems: PropTypes.array,
  trackingPage: PropTypes.string,
  trackingPageId: PropTypes.string,
  addedItemsAttributes: PropTypes.object,
  // todo: specifiy object shape
  extraItemsMeta: PropTypes.object,
  // todo: specifiy object shape
  categoryItemsMeta: PropTypes.object,
  // todo: specifiy object shape
  'data-test': PropTypes.string,
  partNumbers: PropTypes.array.isRequired,
  warrantyItemsList: PropTypes.array.isRequired,
  extraItemsList: PropTypes.array.isRequired,
  isReady: PropTypes.bool.isRequired,
  setItemsLoaded: PropTypes.func
};
ModalSuccessState.defaultProps = {
  hideExtras: false,
  hideWarranties: false,
  hideCategories: false,
  onClickAdd: function onClickAdd() {},
  'data-test': 'component-att'
};
export default ModalSuccessState;